<template>
    <div style="background-color: whitesmoke;">
        <b-modal id="modal-1"  hide-footer hide-header centered no-close-on-backdrop>
            <b-progress value="100" max="100" animated variant="secondary"></b-progress>
        </b-modal>
        <CCardBody class="money-detail">
            <CCol sm="12">
               <!--  <div style="margin-bottom: 5px;">
                    <span style="color: blue;">{{ $t("Filters") }}</span>
                </div> -->
                <table class="search-table" style="width: 1480px; min-width: 1480px; overflow-x: hidden !important;">
                    <tr style="background: #DDD9C4;">
                        <th class="dualHeader1" colspan="1" style="width: 340px; min-width: 340px">{{ $t("Strategy Name") }}</th>
                        <th class="dualHeader1" colspan="1" style="width: 130px; min-width: 130px">{{ $t("Strikes left") }}</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px"><span style="display: block">{{ $t("New") }}</span><span> {{ $t("Target") }}</span></th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px;"><span style="display: block">{{ $t("N. prese") }} </span><span>{{ $t("richieste") }}</span></th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">{{ $t("Budget") }}</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">{{ $t("ROI %") }}</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">{{ $t("ROI ($)") }}</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px"><span style="display: block">{{ $t("Max. Risk") }}</span><span>{{ $t("Achieved") }}</span></th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px"><span style="display: block">{{ $t("Max. Risk") }}</span><span>{{ $t("Current") }}</span></th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px"><span style="display: block">{{ $t("Current") }}</span><span>{{ $t("Risk") }}</span></th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px"><span style="display: block">{{ $t("Won:Part") }}</span><span>{{ $t("Won") }}</span></th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px"><span style="display: block">{{ $t("Loss:Part") }}</span><span>{{ $t("Loss") }}</span></th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">BF %</th>
                        
                        
                    </tr>
                    <tr> 
                        <td style="padding: 0px; background: #FCE4D6">
                            <CInput style="margin-bottom:  0px;" type="text" :value.sync="mainData.strategy_name"></CInput>
                        </td> 
                        <td v-if="mainData.strikes_left=='End'" style="padding: 0px; background: green; color: white;">
                            <span v-if="mainData.strikes_left">
                                {{$t("End")}}
                            </span>                           
                        </td>
                        <td v-else style="padding: 0px; background: #FFFF99">
                            <span v-if="mainData.strikes_left">
                                {{parseFloat(mainData.strikes_left).toFixed(2)}}
                            </span>                           
                        </td> 
                        <td style="padding: 0px">
                           <CInput style="margin-bottom:  0px;" type="number" :value="mainData.new_target" :disabled="!mainData.new_target_start" @change="update_new_target"></CInput>
                        </td>
                        <td style="padding: 0px">
                           <CInput style="margin-bottom:  0px;" type="number" :value="mainData.strikes" @change="update_strikes"></CInput>
                        </td>
                            <CInput style="margin-bottom:  0px;" type="number" :value="mainData.budget" @change="update_budget"></CInput>
                        </td> 
                        <td style="padding: 0px">
                            <CInput style="margin-bottom:  0px;" type="number" :value="mainData.roi_percent" @change="update_roi_percent"></CInput>
                        </td> 
                        <td style="padding: 0px; background: #A6A6A6; color: white;">
                            <span v-if="mainData.roi_money">
                                {{parseFloat(mainData.roi_money).toFixed(2)}}
                            </span>
                        </td>
                        <td style="padding: 0px; background: #A6A6A6; color: white;">
                            <span v-if="mainData.max_risk_achieved">
                                {{parseFloat(mainData.max_risk_achieved).toFixed(2)}}
                            </span>
                        </td>
                        <td style="padding: 0px; background: #A6A6A6; color: white;">
                            <span v-if="mainData.max_risk_current">
                                {{parseFloat(mainData.max_risk_current).toFixed(2)}}
                            </span>
                        </td>
                        <td style="padding: 0px; background: #A6A6A6; color: white;">
                            <span v-if="mainData.current_risk">
                                {{parseFloat(mainData.current_risk).toFixed(2)}}
                            </span>
                        </td>
                        <td style="padding: 0px; background: #A6A6A6; color: white;">                        
                            {{mainData.won}}                       
                        </td>
                        <td style="padding: 0px; background: #A6A6A6; color: white;">
                            {{mainData.loss}}                       
                        </td>
                        <td style="padding: 0px">
                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="mainData.bf"></CInput>
                        </td>
                    </tr>
                    
                </table>
            </CCol>
            <div style="padding-left: 10px;">
                <CButton color="info" class="m-2" @click="save">{{ $t("Save progresses") }}</CButton>
            </div>
            <CCol sm="12">
               <!--  <div style="margin-bottom: 5px;">
                    <span style="color: blue;">{{ $t("Result") }}</span>
                </div> -->
                <table class="search-table table-responsive" style="width: 1480px; min-width: 1480px; overflow-x: hidden !important;margin-top: 0px !important;">
                <!-- <table class="search-table table-responsive" style=""> -->
                    <tr style="background: #DDD9C4;" class="stick-head">
                        <th class="dualHeader1" colspan="1" style="width: 40px; min-width: 40px">{{ $t("N.") }}</th>
                        <th class="dualHeader1" colspan="1" style="width: 80px; min-width: 80px">{{ $t("Multi") }}</th>
                        <th class="dualHeader1" colspan="1" style="width: 350px; min-width: 350px">{{ $t("Events") }}</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px"><span style="display: block">{{ $t("New") }}</span><span> {{ $t("Target") }}</span></th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px"><span style="display: block;">{{ $t("Back") }}</span><span>{{ $t("Lay") }}</span></th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">{{ $t("Odd") }}</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">{{ $t("Stake") }}</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">{{ $t("Outcome") }}</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">{{ $t("Real profit") }}</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px"><span style="display: block;">{{ $t("Max gross") }}</span><span>{{ $t("profit.") }}</span></th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">{{ $t("Net profit") }}</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px"><span style="display: block;">{{ $t("Progressive") }}</span><span>{{ $t("profit") }}</span></th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px"><span style="display: block;">{{ $t("Current.") }}</span><span>{{ $t("bank") }}</span></th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">BF</th>
                        <!-- <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">RCol</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">QCol</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">adCol</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">aeCol</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">afCol</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">agCol</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">AH</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">Y</th>
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">AC</th>
                       
                        <th class="dualHeader1" colspan="1" style="width: 90px; min-width: 90px">AI</th> -->
                        
                    </tr>
                    <tr v-for="(item, index) in filtered_moneyRows">
                        <td style="background: #D9D9D9;">{{index+1}}</td>
                        <td style="padding: 0px">
                            <CSelect
                                style="margin-bottom:  0px;"
                                :options="multi_options"
                                :value.sync="moneyRows[index].multi"
                                :class="{'bg_multi_green' : (moneyRows[index].multi == 'FINE' || moneyRows[index].multi == 'TRUE')}"
                            />
                        </td>
                        <td style="padding: 0px">
                            <CInput style="margin-bottom:  0px;" type="text" :value.sync="moneyRows[index].event"></CInput>
                        </td>
                        <td style="padding: 0px">
                            <CSelect
                                style="margin-bottom:  0px;"
                                :options="newTargetStart_options"
                                :value.sync="moneyRows[index].newTargetStart"
                                @update:value="newTargetStart"
                                :disabled="mainData.new_target_start && moneyRows[index].newTargetStart != 'Start'"
                                :class="{'bg_newtarget_start' : moneyRows[index].newTargetStart == 'Start'}"
                            />
                        </td>
                        <td style="padding: 0px">
                            <CSelect
                                style="margin-bottom:  0px;"
                                :options="backLay_options"
                                :value.sync="moneyRows[index].backLay"
                            />
                        </td>
                        <td style="padding: 0px">
                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="moneyRows[index].odd"></CInput>
                        </td>
                        <td style="padding: 0px; background: #CCFFFF;">
                            <span v-if="moneyRows[index].stake">
                                {{parseFloat(moneyRows[index].stake).toFixed(2)}}
                            </span>
                        </td>
                        <td style="padding: 0px">
                            <CSelect
                                style="margin-bottom:  0px;"
                                :options="outcome_options"
                                :value.sync="moneyRows[index].outcome"
                                :class="{'bg_outcome_v' : moneyRows[index].outcome == 'V', 'bg_outcome_p' : moneyRows[index].outcome == 'P', 'bg_outcome_void' : moneyRows[index].outcome == 'VOID'}"
                                @change="update_rows"
                            />
                        </td>
                        <td style="padding: 0px">
                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="moneyRows[index].realProfit"></CInput>
                        </td>
                        <td style="padding: 0px; background: #D9D9D9;">
                            <span v-if="moneyRows[index].maxGrossProfit">
                                {{parseFloat(moneyRows[index].maxGrossProfit).toFixed(2)}}
                            </span>
                        </td>
                        <td style="padding: 0px; background: #D9D9D9;">
                            <span v-if="moneyRows[index].netProfit">
                                {{parseFloat(moneyRows[index].netProfit).toFixed(2)}}
                            </span>
                        </td>
                        <td style="padding: 0px; background: #D9D9D9;">
                            <span v-if="moneyRows[index].progressiveProfit">
                                {{parseFloat(moneyRows[index].progressiveProfit).toFixed(2)}}
                            </span>
                        </td>
                        <td style="padding: 0px; background: #D9D9D9;">
                            <span v-if="moneyRows[index].currentBank">
                                {{parseFloat(moneyRows[index].currentBank).toFixed(2)}}
                            </span>
                        </td>
                        <td style="padding: 0px">
                            <CSelect
                                style="margin-bottom:  0px;"
                                :options="bf_options"
                                :value.sync="moneyRows[index].bf"
                            />
                        </td>
                        <!-- <td>{{moneyRows[index].aqCol}}</td>
                        <td>{{moneyRows[index].vCol}}</td>
                        <td>{{moneyRows[index].asCol}}</td>
                        <td>{{moneyRows[index].sCol}}</td> -->
                        <!-- <td>{{moneyRows[index].rCol}}</td>
                        <td>{{moneyRows[index].qCol}}</td>
                        <td>{{moneyRows[index].adCol}}</td>
                        <td>{{moneyRows[index].aeCol}}</td>
                        <td>{{moneyRows[index].afCol}}</td>
                        <td>{{moneyRows[index].agCol}}</td>
                        <td>{{moneyRows[index].ahCol}}</td>
                        <td>{{moneyRows[index].yCol}}</td>
                        <td>{{moneyRows[index].acCol}}</td>
                        <td>{{moneyRows[index].aiCol}}</td> -->

                    </tr>
                    
                </table>
            </CCol>
            
        </CCardBody>

        

    </div>
</template>

<script>
import { Plotly } from 'vue-plotly'
import swal from "sweetalert2";
import {displaySuccess, displayError} from '@/helpers/message';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'FinancialTable',
    components: {
        Plotly,
       
    },
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            mainData: {
                strategy_name: "",
                strikes_left: "",
                new_target: "",
                strikes: "",
                budget: "",
                roi_percent: "",
                roi_money: "",
                max_risk_achieved: "",
                max_risk_current: "",
                current_risk: "",
                current_bank: "",
                current_roi: "",
                won: "0 : 0",
                loss: "0 : 0",
                bf: "",
                new_target_start: false,
            },            
            moneyRows: [
                
            ],
            multi_options: [
                { value: 'Annulla', label: this.$t('Cancel ')},
                { value: 'TRUE', label: this.$t('Add ')},
                { value: 'FINE', label: this.$t('End')},
                { value: '', label: ""}
            ],
            newTargetStart_options: [
                { value: 'Annulla', label: this.$t('Annulla')},
                { value: 'Start', label: this.$t('Start')},
                { value: '', label: ""}
            ],
            backLay_options: [
                { value: 'Back', label: this.$t('Back')},
                { value: 'Lay', label: this.$t('Lay')}
            ],
            outcome_options: [
                { value: 'V', label: this.$t('W')},
                { value: 'P', label: 'L '},
                { value: 'VOID', label: 'VOID'},
                { value: '', label: ""}
            ],
            bf_options: [
                { value: 's', label: this.$t('Yes')},
                { value: 'n', label: this.$t('No')},                
                { value: '', label: ""}
            ],

            pCol4: 65,

            loading: true
        }
    },
    created() {
        this.init();
    },
    mounted: function (){
        this.$nextTick(function () {
            console.log('==============  mounted function')
            

        })
    },
    methods: {
        ...mapActions([
                'getMoneyDetails',
                'saveMoneyDetails'
            ]),
        
        showModal() {
            // this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')

            console.log('show modal')
            this.$bvModal.show('modal-1')
            console.log('show modal close')
        },
        hideModal() {
            this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
        },

        newTargetStart(evt) {
            if (evt == "Start")
                this.mainData.new_target_start = true;
            else
                this.mainData.new_target_start = false;
        },

        init() {
            this.getMoneyDetails({_id: this.$route.params.id}).then((data) => {
                let moneyManagement = data.moneyManagement;
                

                if ( moneyManagement.length > 0 ) {
                    this.mainData.strategy_name = moneyManagement[0].name;                    
                    this.mainData.strikes = moneyManagement[0].strikes;
                    this.mainData.budget = moneyManagement[0].budget;
                    this.mainData.roi_percent = moneyManagement[0].roi_percent;                    
                    this.mainData.bf = moneyManagement[0].bf;

                    if (moneyManagement[0].rows)
                        this.moneyRows = moneyManagement[0].rows;

                    if (moneyManagement[0].new_target)
                        this.mainData.new_target = moneyManagement[0].new_target;
                    else
                        this.mainData.new_target = moneyManagement[0].strikes;
                    // if (this.moneyRows.length == 0)
                    this.update_rows();

                    if (moneyManagement[0].roi_money)
                        this.mainData.roi_money = parseFloat(moneyManagement[0].roi_money);
                    else
                        this.mainData.roi_money = moneyManagement[0].budget * moneyManagement[0].roi_percent / 100 ;

                    if (moneyManagement[0].won)
                        this.mainData.won = moneyManagement[0].won;
                    if (moneyManagement[0].loss)
                        this.mainData.loss = moneyManagement[0].loss;
                    if (moneyManagement[0].new_target_start)
                        this.mainData.new_target_start = moneyManagement[0].new_target_start;

                }                
            });

        },

        save() {
            let params = {
                ...this.mainData,
                rows: this.filtered_moneyRows
            };
            this.saveMoneyDetails({_id: this.$route.params.id, params: params}).then((data) => {
                 displaySuccess({message: "Update Money Details Successfully"});
            });
        },
        update_rows() {
            let strikes = parseInt(this.mainData.strikes);
            if (this.mainData.new_target_start)
                strikes = parseInt(this.mainData.new_target);

            if ( !strikes )
                return;
            let positive_tips = this.moneyRows.filter( item => item.outcome == "V" );
            let not_settled_tips = this.moneyRows.filter( item => item.outcome == "" );
            console.log("strikes length", strikes)
            console.log("positive_tips length", positive_tips.length)
            console.log("not_settled_tips length", not_settled_tips.length)
            console.log("this.mainData.strikes_left length", this.mainData.strikes_left)
            if (strikes > positive_tips.length) {
                let new_rows_num = strikes - positive_tips.length - not_settled_tips.length;
                console.log("new_rows_num length", new_rows_num)
                if ( new_rows_num > 0 ) {
                    for ( var i=0; i<new_rows_num; i++ ) {
                        this.moneyRows.push({
                            
                            multi: "",
                            event: "",
                            newTargetStart: "",
                            backLay: "Back",
                            odd: "",
                            stake: "",
                            outcome: "",
                            realProfit: "",
                            maxGrossProfit: "",
                            netProfit: "",
                            progressiveProfit: "",
                            currentBank: "",
                            bf: "",
                            
                        })
                    }
                }
                else {
                    this.moneyRows = this.moneyRows.slice(0, this.moneyRows.length + new_rows_num);
                }
            }
            else {
                let new_money_rows = [];
                let positive_result = 0;
                for ( var i=0; i<this.moneyRows.length; i++ ) {
                    if (this.moneyRows[i].outcome == "V")
                        positive_result += 1;
                    if (positive_result == strikes && this.moneyRows[i].outcome == "")
                        break;
                    new_money_rows.push(this.moneyRows[i]);                    
                }
                if ( this.mainData.strikes_left != "End" && this.mainData.strikes_left != "") {
                    let new_rows_num = Math.ceil(parseFloat(this.mainData.strikes_left));

                    console.log("===new_rows_num", new_rows_num)
                    
                    for ( var i=0; i<new_rows_num; i++ ) {
                        console.log("add ", i)
                        new_money_rows.push({
                            
                            multi: "",
                            event: "",
                            newTargetStart: "",
                            backLay: "Back",
                            odd: "",
                            stake: "",
                            outcome: "",
                            realProfit: "",
                            maxGrossProfit: "",
                            netProfit: "",
                            progressiveProfit: "",
                            currentBank: "",
                            bf: "",
                            
                        })
                    }
                    
                }

                this.moneyRows = new_money_rows;
            }
        },
        update_new_target(evt) {
            if (!evt)
                return;
            this.mainData.new_target = parseInt(evt);
            this.update_rows();
        },

        update_strikes(evt) {
           
            if ( !evt )
                return;

            
            let old_strikes = 0;
            if (this.mainData.strikes)
                old_strikes = parseInt(this.mainData.strikes);
            
            let diff_strikes = parseInt(evt) - old_strikes;

            if (old_strikes == 0)
                this.mainData.new_target = parseInt(evt);
            else
                this.mainData.new_target = diff_strikes + old_strikes;
            
            this.mainData.strikes = parseInt(evt)
            this.update_rows();
        },
        update_budget(evt) {
            this.mainData.budget = evt;
            if (this.mainData.budget && this.mainData.roi_percent)
                this.mainData.roi_money = this.mainData.budget * this.mainData.roi_percent / 100;
            else
                this.mainData.roi_money = 0;
        },
        update_roi_percent(evt) {
            this.mainData.roi_percent = evt;
            if (this.mainData.budget && this.mainData.roi_percent)
                this.mainData.roi_money = this.mainData.budget * this.mainData.roi_percent / 100;
            else
                this.mainData.roi_money = 0;
        },

        get_aaCol(row, lastRow) {
            if (row.multi == "TRUE" || (lastRow != null && lastRow.multi == "TRUE")) {

                return 1;
            }
            else
                return 0;
        },

        get_apCol(row, lastRow) {
            let pCol6 = this.pCol6;
            if (lastRow == null) {
                if (row.newTargetStart == "Start") {
                    return pCol6;
                }
                else
                    return 0;
            }
            else {
                if (lastRow.apCol == pCol6)
                    return pCol6;
                else if (row.newTargetStart == "Start") {
                    return pCol6;
                }
                else
                    return 0;
            }
        },
        get_auCol(row, lastRow) {
            let last_ap = 0;
            if (lastRow)
                last_ap = lastRow.apCol;
            if (last_ap == 0 && row.apCol != 0)
                return row.apCol;
            else
                return 0;            
        },

        get_pCol(row, lastRow) {
            let pCol;
            if (lastRow == null){
                if (row.outcome == "")
                    pCol = this.pCol6;
                else
                    pCol = 0;
            }
            else {
                if (row.outcome == "" && lastRow.outcome != "")
                    pCol = this.pCol6;
                else
                    pCol = 0;
            }
            return pCol;
        },

        get_rCol(row, lastRow) {
            let rCol;
            if (lastRow == null){
                rCol = parseFloat(this.mainData.strikes);
            } 

            else {
                let pCol6 = this.pCol6;

                if (row.aaCol == 1 && row.apCol != 0) {
                    let compVal = row.auCol;
                    if (row.auCol <= 0)
                        compVal = Math.abs(lastRow.rCol - lastRow.qCol);
                    if (compVal > 0 && compVal < 1)
                        rCol = 1;
                    else if (row.auCol <= 0)
                        rCol = Math.abs(lastRow.rCol - lastRow.qCol);
                    else
                        rCol = row.auCol + (lastRow.rCol - lastRow.qCol);
                }
                else {
                    if (row.apCol != 0) {
                        if (row.multi == "TRUE" || row.multi == "FINE")
                            rCol = lastRow.rCol - lastRow.qCol;
                        else {
                            let compVal = row.auCol;
                            if (row.auCol <= 0)
                                compVal = Math.abs(lastRow.rCol - lastRow.qCol);
                            if (compVal > 0 && compVal < 1)
                                rCol = 1;
                            else if (row.auCol <= 0)
                                rCol = Math.abs(lastRow.rCol - lastRow.qCol);
                            else
                                rCol = row.auCol + (lastRow.rCol - lastRow.qCol);
                        }
                    }
                    else {
                        if (row.multi == "TRUE" || row.multi == "FINE")
                            rCol = lastRow.rCol - lastRow.qCol;
                        else {
                            let compVal = row.pCol;
                            if (row.pCol <= 0)
                                compVal = Math.abs(lastRow.rCol - lastRow.qCol);
                            if (compVal > 0 && compVal < 1)
                                rCol = 1;
                            else if (row.pCol <= 0)
                                rCol = Math.abs(lastRow.rCol - lastRow.qCol);
                            else
                                rCol = row.pCol + (lastRow.rCol - lastRow.qCol);
                        }
                    }

                }
            }
            return rCol;
        },

        get_tCol(row, lastRow) {
            let tCol = 0;
            if ( row.multi == "TRUE" || row.multi == "FINE" ) {
                if (row.backLay == "Lay")
                    tCol = row.odd / ( row.odd - 1);
                else
                    tCol = parseFloat(row.odd);
            }
            return tCol;
        },

        get_xCol(row, lastRows) {
            let _filtered = lastRows.filter( item => item.multi == "FINE");
            let xCol = 0;
            if ( row.multi == "FINE" ){
                xCol = _filtered.length - 1;
            }
            else
                xCol = _filtered.length;
            return xCol;
        },

        get_sCol(row, lastRow) {
            let sCol;
            if ( row.multi == "FINE" || row.multi == "TRUE" ) {
                sCol = 0;
                for ( let i=0; i< this.moneyRows.length; i++ ) {
                    
                    let _row = this.moneyRows[i];
                    if (( _row.multi == "FINE" || _row.multi == "TRUE" ) && _row.xCol == row.xCol )
                        sCol += _row.tCol;
                }
            }
            else {
                if (lastRow == null)
                    sCol = 0;
                else
                    sCol = lastRow.sCol;
            }
            return sCol;
        },

        get_uCol(row, lastRow) {
            if (row.odd == "")
                return "";
            let odd = parseFloat(row.odd);
            let roi_money = parseFloat(this.mainData.roi_money);

            let vCol = 0;
            if (lastRow)
                vCol = parseFloat(lastRow.vCol);

            let uCol;
            if (row.multi == "TRUE" || row.multi == "FINE") {
                if (row.backLay == "Lay") {
                    uCol = (odd * (roi_money - vCol) / row.rCol / odd) * ( odd / (odd - 1)) / row.sCol;
                }
                else {
                    uCol = ((roi_money - vCol) / row.rCol / (odd - 1)) * ( odd / row.sCol);
                }
            }
            else {
                if (row.backLay == "Back") {
                    if ( odd == "" ){
                        uCol = "";
                    }
                    else {
                        uCol = (roi_money - vCol) / row.rCol / (odd - 1) ;
                    }
                    
                }
                else {
                    if ( odd == "" ){
                        uCol = "";
                    }
                    else {
                        uCol = odd * (roi_money - vCol) / row.rCol / odd ;
                    }
                }
            }
            return uCol;
        },
        get_vCol(row, lastRow) {
            let vCol;
            let last_vCol = 0;
            if (lastRow)
                last_vCol = lastRow.vCol;
            if (row.multi == "TRUE") {
                vCol = last_vCol;
            }
            else if (row.outcome == "")
                vCol = "";
            else if (row.odd == "")
                vCol = "";
            else
                vCol = row.progressiveProfit;
            return vCol;

        },
        get_asCol(row, lastRow) {
            let asCol;
            let last_rCol;
            let last_asCol;
            let last_bCol;
            if (lastRow == null){
                last_rCol = parseFloat(this.mainData.strikes);
                last_asCol = parseFloat(this.mainData.strikes);
                last_bCol = "";
            }
            else{
                last_rCol = lastRow.rCol;
                last_asCol = lastRow.asCol;
                last_bCol = lastRow.multi;
            }

            
            if ( row.multi == "TRUE" && ( last_bCol == "FINE" || last_bCol == "Annulla" || last_bCol == "" ) ) {
                asCol = last_rCol - 1;
            }
            else {
                asCol = last_asCol;
            }
            return asCol;
        },
        get_aqCol(row, lastRow) {
            if (row.odd == "")
                return "";
            let odd = parseFloat(row.odd);
            let roi_money = parseFloat(this.mainData.roi_money);

            let vCol = 0;
            if (lastRow)
                vCol = parseFloat(lastRow.vCol);

            let aqCol;
            if (row.multi == "TRUE" || row.multi == "FINE") {
                if (row.backLay == "Lay") {
                    aqCol = (odd * (roi_money - vCol) / row.asCol / odd) * ( odd / (odd - 1)) / row.sCol;
                }
                else {
                    aqCol = ((roi_money - vCol) / row.asCol / (odd - 1)) * ( odd / row.sCol);
                }
            }
            else {
                if (row.backLay == "Back") {
                    if ( odd == "" ){
                        aqCol = "";
                    }
                    else {
                        aqCol = (roi_money - vCol) / row.asCol / (odd - 1) ;
                    }
                    
                }
                else {
                    if ( odd == "" ){
                        aqCol = "";
                    }
                    else {
                        aqCol = odd * (roi_money - vCol) / row.asCol / odd ;
                    }
                }
            }
            return aqCol;
        },

        get_stake(row, lastRow) {
            if (row.aaCol == 1)
                return row.aqCol;
            else
                return row.uCol;
        },

        get_maxGrossProfit(row) {

            let maxGrossProfit = "";
            if (row.outcome != "") {
                if (row.odd != "" && row.stake != "") {
                    let odd = parseFloat(row.odd);
                    let stake = parseFloat(row.stake);

                    if (row.backLay == "Back") {                    
                        if (row.outcome == "V") {
                            maxGrossProfit = odd * stake;
                        }
                        else if (row.outcome == "1/2V") {
                            maxGrossProfit = stake / 2 + odd * stake / 2;
                        }
                        else if (row.outcome == "1/2P") {
                            maxGrossProfit = stake / 2;
                        }
                        else if (row.outcome == "VOID") {
                            maxGrossProfit = stake;
                        }
                        else {
                            maxGrossProfit = stake * -1;
                        }

                    }
                    else if (row.backLay == "Lay") {
                    
                        if (row.outcome == "V") {
                            maxGrossProfit = stake;
                        }
                        else if (row.outcome == "1/2V") {
                            maxGrossProfit = stake / 2 + (odd / odd - 1) * stake / 2;
                        }
                        else if (row.outcome == "1/2P") {
                            maxGrossProfit = stake / 2;
                        }
                        else if (row.outcome == "VOID") {
                            maxGrossProfit = stake;
                        }
                        else {
                            maxGrossProfit = stake - stake * odd;
                        }

                    }
                }
            }
            return maxGrossProfit;

        },

        get_netProfit(row) {
            let netProfit = "";
            if (row.outcome != "") {
                let bf = 0;
                if (this.mainData.bf)
                    bf = this.mainData.bf / 100;
                if (row.backLay == "Back") {
                    if (row.odd != "") {
                        if (row.realProfit == "") {
                            if (row.maxGrossProfit < 0)
                               netProfit = row.maxGrossProfit;
                            else if (row.bf == "s")
                                netProfit = ( row.maxGrossProfit - row.stake ) * ( 1 - bf);
                            else
                                netProfit = row.maxGrossProfit - row.stake;

                        }
                        else
                            netProfit = row.realProfit;
                    }
                }
                else {
                    if (row.outcome == "VOID")
                        netProfit = 0;
                    else {

                        if (row.odd == "")
                            netProfit = "";
                        else {
                            if (row.realProfit == "") {
                                if (row.maxGrossProfit < 0)
                                    netProfit = row.stake - row.stake * row.odd;
                                else if (row.bf == "s")
                                    netProfit = row.stake * ( 1 - bf);
                                else
                                    netProfit = row.stake;
                            }
                            else {
                                netProfit = row.realProfit;
                            }
                        }
                    }
                }
            }
            return netProfit;
        },
        get_progressiveProfit(row, lastRow) {
            let progressiveProfit;
            if (row.outcome == "")
                progressiveProfit = "";
            else if (row.odd == "")
                progressiveProfit = "";
            else {
                if (lastRow)
                    progressiveProfit = parseFloat(row.netProfit) + parseFloat(lastRow.progressiveProfit);
                else
                    progressiveProfit = parseFloat(row.netProfit);
            }
            return progressiveProfit;
        },
        get_currentBank(row, lastRow) {
            let currentBank;
            if (row.outcome == "")
                currentBank = "";
            else if (row.odd == "")
                currentBank = "";
            else
                currentBank = (parseFloat(row.progressiveProfit) + parseFloat(this.mainData.budget)).toFixed(2);
            return currentBank;
        },
        get_abCol(row, lastRow){
            let abCol = "";
            if (row.odd != "" && row.stake != "") {
                let odd = parseFloat(row.odd);
                let stake = parseFloat(row.stake);
                if (row.aaCol == 1) {
                    if (row.outcome == "")
                        abCol = row.aqCol;
                    else if (row.backLay == "Back") {
                        if (row.outcome == "")
                            abCol = odd * stake;
                        else if (row.outcome == "V")
                            abCol = odd * stake;
                        else if (row.outcome == "1/2V")
                            abCol = stake / 2 + stake / 2 * odd;
                        else if (row.outcome == "1/2F")
                            abCol = stake / 2;
                        else if (row.outcome == "VOID")
                            abCol = stake;
                        else
                            abCol = odd * stake;
                    }
                    else {
                        if (row.outcome == "")
                            abCol = stake;
                        else if (row.outcome == "V")
                            abCol = stake;
                        else if (row.outcome == "1/2V")
                            abCol = stake / 2 + stake / 2 * (odd / ( odd - 1 ));
                        else if (row.outcome == "1/2F")
                            abCol = stake / 2;
                        else if (row.outcome == "VOID")
                            abCol = stake;
                        else
                            abCol = stake;
                    }                    
                }
            }
            return abCol;
        },
        get_adCol(row, lastRow){
            let adCol = 0;

            if (row.odd != "" && row.stake != "") {
                let odd = parseFloat(row.odd);
                let stake = parseFloat(row.stake);
                let bf = 0;
                if (this.mainData.bf)
                    bf = this.mainData.bf / 100;
                
                if (row.aaCol == 0)
                    adCol =  "";
                else {
                    if (row.outcome == "")
                        adCol = row.aqCol;
                    else if (row.backLay == "Back") {
                        if ( row.odd == "" )
                            adCol = "";
                        else if ( row.realProfit == "" ) {
                            if ( row.maxGrossProfit < 0 )
                                adCol = row.maxGrossProfit;
                            else if (row.bf == "s")
                                adCol = (row.maxGrossProfit - stake) * (1 - bf);
                            else
                                adCol = row.maxGrossProfit - stake
                        }
                        else
                            adCol = row.realProfit;
                    }
                    else {
                        if ( row.outcome == "VOID" )
                            adCol = 0;
                        else if ( row.odd == "" )
                            adCol = "";
                        else if ( row.realProfit == "" ) {
                            if ( row.maxGrossProfit < 0 )
                                adCol = stake - stake * odd;
                            else if (row.bf == "s")
                                adCol = stake * (1 - bf);
                            else
                                adCol = stake
                        }
                        else
                            adCol = row.realProfit;
                    }

                }
                if ( adCol < 0 )
                    adCol = row.abCol;
               
            }
            return adCol;
        },
        get_acCol(row) {
            let acCol = 0;

            if (row.odd != "" && row.stake != "") {
                let odd = parseFloat(row.odd);
                let stake = parseFloat(row.stake);
                let bf = 0;
                if (this.mainData.bf)
                    bf = this.mainData.bf / 100;
                
                if (row.aaCol == 0)
                    acCol =  "";
                else {
                    if (row.outcome == "")
                        acCol = row.aqCol;
                    else if (row.backLay == "Back") {
                        if ( row.odd == "" )
                            acCol = "";
                        else if ( row.abCol < 0 ) 
                            acCol = row.abCol;
                            
                        else if (row.bf == "s")
                            acCol = (row.abCol - stake) * (1 - bf);
                        else
                            acCol = row.abCol - stake
                        
                        
                    }
                    else {
                        if ( row.outcome == "VOID" )
                            acCol = 0;
                        else if ( row.odd == "" )
                            acCol = "";
                        else if ( row.abCol < 0 )
                            acCol = stake - stake * odd;
                        else if (row.bf == "s")
                            acCol = stake * (1 - bf);
                        else
                            acCol = stake
                       
                    }

                }
               
            }
            return acCol;
        },
        get_aeCol(row, lastRows) {
            let aeCol = 0;
            if (row.aaCol == 1) {
                if (row.multi == "TRUE" || row.multi == "FINE") {
                    let _filtered = lastRows.filter( item => item.multi == "FINE" || item.multi == "TRUE");
                    if (lastRows.length == 3) {
                        console.log("===============   _filtered:", _filtered)
                    }
                    for ( let i=0; i < _filtered.length; i++) {
                        if (_filtered[i].yCol === row.yCol)
                            aeCol += _filtered[i].acCol;
                    }                    
                }
                else
                    aeCol = row.acCol;
            }
            
            return aeCol;
        },
        get_agCol(row, lastRows, nextRow) {
            let agCol = 0;
            let yColComp = row.yCol;
            if (nextRow && row.yCol == nextRow.yCol)
                yColComp = "";
            for ( let i=0; i < lastRows.length; i++) {
                if (lastRows[i].yCol === yColComp && lastRows[i].aaCol == 1)
                    agCol += 1;
            }
            return agCol;

        },
        get_ahCol(row, rowIndex){
            //ae, ag
            let nextRows = this.moneyRows.slice(rowIndex);
            let ahCol = 1;
            const found_index = nextRows.findIndex(element => element.agCol > 0);
            if (found_index > -1)
                ahCol = nextRows[found_index].aeCol;
            return ahCol;
        },
        get_afCol(row, lastRow){
            let afCol = 0;
            if (row.aaCol != 0)
                afCol =  row.adCol / row.ahCol;
            return afCol;
        },
        get_qCol(row, lastRow) {
            let qCol = 0;
            if (row.odd != "" && row.stake != "") {
                let odd = parseFloat(row.odd);
                let stake = parseFloat(row.stake);
                if (row.aaCol == 1 && row.auCol != 0) {
                    if (row.backLay == "Back") {
                        if (row.outcome == "V" && row.realProfit == "") {
                            qCol = 1;
                        }
                        else if (row.outcome == "V" && row.realProfit > 0) {
                            qCol = 1 * ( row.realProfit / ( ( odd * stake ) - stake ) );
                        }
                        else if (row.outcome == "1/2V" ) {
                            qCol = 0.5;
                        }
                        else if (row.outcome == "1/2P" ) {
                            qCol = -0.5;
                        }
                        else if (row.outcome == "P" && row.realProfit == "") {
                            qCol = 0;
                        }
                        else if (row.outcome == "P" && row.realProfit < 0) {
                            qCol = 0;
                        }
                    }
                    else {
                        if (row.outcome == "V" && row.realProfit == "") {
                            qCol = 1;
                        }
                        else if (row.outcome == "V" && row.realProfit > 0) {
                            qCol = 1 * ( row.realProfit / stake );
                        }
                        else if (row.outcome == "1/2V" ) {
                            qCol = 0.5;
                        }
                        else if (row.outcome == "1/2P" ) {
                            qCol = -0.5;
                        }
                        else if (row.outcome == "P" && row.realProfit == "") {
                            qCol = 0;
                        }
                        else if (row.outcome == "P" && row.realProfit < 0) {
                            qCol = 0;
                        }
                    }
                }
                else if (row.aaCol == 1) {
                    if (row.backLay == "Back") {
                        if (row.outcome == "V" && row.realProfit == "") {
                            qCol = row.afCol;
                        }
                        else if (row.outcome == "V" && row.realProfit > 0) {
                            qCol = row.afCol;
                        }                       
                        else if (row.outcome == "P" && row.realProfit == "") {
                            qCol = 0;
                        }
                        else if (row.outcome == "P" && row.realProfit < 0) {
                            qCol = 0;
                        }
                    }
                    else {
                        if (row.outcome == "V" && row.realProfit == "") {
                            qCol = row.afCol;
                        }                        
                        else if (row.outcome == "P" && row.realProfit == "") {
                            qCol = 0;
                        }
                        else if (row.outcome == "P" && row.realProfit < 0) {
                            qCol = 0;
                        }
                    }
                }
                else {
                     
                    if (row.backLay == "Back") {
                        if (row.outcome == "V" && row.realProfit == "") {
                            qCol = 1;
                        }
                        else if (row.outcome == "V" && row.realProfit > 0) {
                            qCol = 1 * ( row.realProfit / ( ( odd * stake ) - stake ) );
                        }
                        else if (row.outcome == "1/2V" ) {
                            qCol = 0.5;
                        }
                        else if (row.outcome == "1/2P" ) {
                            qCol = -0.5;
                        }
                        else if (row.outcome == "P" && row.realProfit == "") {
                            qCol = 0;
                        }
                        else if (row.outcome == "P" && row.realProfit < 0) {
                            qCol = 0;
                        }
                    }
                    else {
                        if (row.outcome == "V" && row.realProfit == "") {
                            qCol = 1;
                        }
                        else if (row.outcome == "V" && row.realProfit > 0) {
                            qCol = 1 * ( row.realProfit / stake );
                        }
                        else if (row.outcome == "1/2V" ) {
                            qCol = 0.5;
                        }
                        else if (row.outcome == "1/2P" ) {
                            qCol = -0.5;
                        }
                        else if (row.outcome == "P" && row.realProfit == "") {
                            qCol = 0;
                        }
                        else if (row.outcome == "P" && row.realProfit < 0) {
                            qCol = 0;
                        }
                    }
                
                }
            }
            return qCol;
        },
        get_aiCol(row, lastRow) {
            if (lastRow == null){
                if (row.rCol > 0)
                    return 1;
                else
                    return 0;
            }
            else {
                if (row.rCol > 0)
                    return lastRow.aiCol + 1;
                else
                    return 0;
            }
        },
    },
    computed: {
        filtered_moneyRows() {
            let _filtered = [];
            for ( let i=0; i< this.moneyRows.length; i++ ) {
                let row = this.moneyRows[i];
                let lastRow = null;
                if ( i > 0 )
                    lastRow = this.moneyRows[i-1];
                let nextRow = null;
                if ( i < (this.moneyRows.length - 1) )
                    nextRow = this.moneyRows[i+1];

                this.moneyRows[i].aaCol = this.get_aaCol(row, lastRow);

                this.moneyRows[i].xCol = this.get_xCol(row, this.moneyRows.slice(0, i+1));
                this.moneyRows[i].yCol = this.moneyRows[i].xCol;
                this.moneyRows[i].tCol = this.get_tCol(row, lastRow);

                this.moneyRows[i].abCol = this.get_abCol(row, lastRow);
                

                //this.moneyRows[i].agCol = this.get_agCol(row, this.moneyRows.slice(0, i+1), nextRow);
                // this.moneyRows[i].ahCol = this.get_ahCol(row, i);

                this.moneyRows[i].acCol = this.get_acCol(row);
                this.moneyRows[i].aeCol = this.get_aeCol(row, this.moneyRows.slice(0, i+1));
            }
            for ( let i=0; i< this.moneyRows.length; i++ ) {
                let row = this.moneyRows[i];
                let lastRow = null;
                if ( i > 0 )
                    lastRow = this.moneyRows[i-1];
                let nextRow = null;
                if ( i < (this.moneyRows.length - 1) )
                    nextRow = this.moneyRows[i+1];                
                this.moneyRows[i].agCol = this.get_agCol(row, this.moneyRows.slice(0, i+1), nextRow);                
            }
            for ( let i=0; i< this.moneyRows.length; i++ ) {
                let row = this.moneyRows[i];
                this.moneyRows[i].ahCol = this.get_ahCol(row, i);
            }           


            for ( let i=0; i< this.moneyRows.length; i++ ) {
                let row = this.moneyRows[i];
                
                let lastRow = null;
                if ( i > 0 )
                    lastRow = this.moneyRows[i-1];

                
                row.apCol = this.get_apCol(row, lastRow); //
                row.auCol = this.get_auCol(row, lastRow); //
                row.pCol = this.get_pCol(row, lastRow);  //
                row.rCol = this.get_rCol(row, lastRow);
                
                row.sCol = this.get_sCol(row, lastRow);  //
                row.uCol = this.get_uCol(row, lastRow);

                console.log("=== row.uCol", row.uCol);

                row.asCol = this.get_asCol(row, lastRow);
                row.aqCol = this.get_aqCol(row, lastRow);
                row.stake = this.get_stake(row, lastRow);

                row.maxGrossProfit = this.get_maxGrossProfit(row);
                row.netProfit = this.get_netProfit(row);
                row.progressiveProfit = this.get_progressiveProfit(row, lastRow);
                row.currentBank = this.get_currentBank(row, lastRow);

                row.adCol = this.get_adCol(row, lastRow);
                row.afCol = this.get_afCol(row, lastRow);
                row.vCol = this.get_vCol(row, lastRow);
                row.qCol = this.get_qCol(row, lastRow);

                // strikes left calc
                row.aiCol = this.get_aiCol(row, lastRow);                
                
                this.moneyRows[i] = row;

            }
            
            for ( let i=0; i< this.moneyRows.length; i++ ) {
                let row = this.moneyRows[i];
                let lastRow = null;
                if ( i > 0 )
                    lastRow = this.moneyRows[i-1];
                let nextRow = null;
                if ( i < (this.moneyRows.length - 1) )
                    nextRow = this.moneyRows[i+1];

                this.moneyRows[i].aaCol = this.get_aaCol(row, lastRow);

                this.moneyRows[i].xCol = this.get_xCol(row, this.moneyRows.slice(0, i+1));
                this.moneyRows[i].yCol = this.moneyRows[i].xCol;
                this.moneyRows[i].tCol = this.get_tCol(row, lastRow);

                this.moneyRows[i].abCol = this.get_abCol(row, lastRow);
                

                //this.moneyRows[i].agCol = this.get_agCol(row, this.moneyRows.slice(0, i+1), nextRow);
                // this.moneyRows[i].ahCol = this.get_ahCol(row, i);

                this.moneyRows[i].acCol = this.get_acCol(row);
                this.moneyRows[i].aeCol = this.get_aeCol(row, this.moneyRows.slice(0, i+1));
            }
            for ( let i=0; i< this.moneyRows.length; i++ ) {
                let row = this.moneyRows[i];
                let lastRow = null;
                if ( i > 0 )
                    lastRow = this.moneyRows[i-1];
                let nextRow = null;
                if ( i < (this.moneyRows.length - 1) )
                    nextRow = this.moneyRows[i+1];                
                this.moneyRows[i].agCol = this.get_agCol(row, this.moneyRows.slice(0, i+1), nextRow);                
            }
            for ( let i=0; i< this.moneyRows.length; i++ ) {
                let row = this.moneyRows[i];
                this.moneyRows[i].ahCol = this.get_ahCol(row, i);
            }

            for ( let i=0; i< this.moneyRows.length; i++ ) {
                let row = this.moneyRows[i];
                
                let lastRow = null;
                if ( i > 0 )
                    lastRow = this.moneyRows[i-1];

                
                row.apCol = this.get_apCol(row, lastRow); //
                row.auCol = this.get_auCol(row, lastRow); //
                row.pCol = this.get_pCol(row, lastRow);  //
                row.rCol = this.get_rCol(row, lastRow);
                
                row.sCol = this.get_sCol(row, lastRow);  //
                row.uCol = this.get_uCol(row, lastRow);

                console.log("=== row.uCol", row.uCol);

                row.asCol = this.get_asCol(row, lastRow);
                row.aqCol = this.get_aqCol(row, lastRow);
                row.stake = this.get_stake(row, lastRow);

                row.maxGrossProfit = this.get_maxGrossProfit(row);
                row.netProfit = this.get_netProfit(row);
                row.progressiveProfit = this.get_progressiveProfit(row, lastRow);
                row.currentBank = this.get_currentBank(row, lastRow);

                row.adCol = this.get_adCol(row, lastRow);
                row.afCol = this.get_afCol(row, lastRow);
                row.vCol = this.get_vCol(row, lastRow);
                row.qCol = this.get_qCol(row, lastRow);

                // strikes left calc
                row.aiCol = this.get_aiCol(row, lastRow);
                if (max_ai < row.aiCol){
                    max_ai = row.aiCol;
                    max_r = row.rCol;
                }
                console.log("row.progressiveProfit",  row.progressiveProfit)
                if (row.progressiveProfit && max_m < row.progressiveProfit){
                    console.log("max m changed",max_m,  row.progressiveProfit)
                    max_m = row.progressiveProfit;
                }
                if (row.qCol == 1 && row.rCol == 1)
                    qr_match = true;

                
                this.moneyRows[i] = row;

                

            }

            let min_progressiveProfit = 0;
            let current_risk = 0;
            let current_bank = 0;
            let current_roi = "";
            let max_risk_current = 0;
            let max_ai = 0;
            let max_r;
            let max_m = -1;
            let qr_match = false;

            let outcome_won = 0;
            let outcome_loss = 0;
            let realProfit_won = 0;
            let realProfit_loss = 0;


            for ( let i=0; i< this.moneyRows.length; i++ ) {
                let row = this.moneyRows[i];
                
                let lastRow = null;
                if ( i > 0 )
                    lastRow = this.moneyRows[i-1];

                
                row.apCol = this.get_apCol(row, lastRow); //
                row.auCol = this.get_auCol(row, lastRow); //
                row.pCol = this.get_pCol(row, lastRow);  //
                row.rCol = this.get_rCol(row, lastRow);
                
                row.sCol = this.get_sCol(row, lastRow);  //
                row.uCol = this.get_uCol(row, lastRow);

                console.log("=== row.uCol", row.uCol);

                row.asCol = this.get_asCol(row, lastRow);
                row.aqCol = this.get_aqCol(row, lastRow);
                row.stake = this.get_stake(row, lastRow);

                row.maxGrossProfit = this.get_maxGrossProfit(row);
                row.netProfit = this.get_netProfit(row);
                row.progressiveProfit = this.get_progressiveProfit(row, lastRow);
                row.currentBank = this.get_currentBank(row, lastRow);

                row.adCol = this.get_adCol(row, lastRow);
                row.afCol = this.get_afCol(row, lastRow);
                row.vCol = this.get_vCol(row, lastRow);
                row.qCol = this.get_qCol(row, lastRow);

                // strikes left calc
                row.aiCol = this.get_aiCol(row, lastRow);
                if (max_ai < row.aiCol){
                    max_ai = row.aiCol;
                    max_r = row.rCol;
                }
                console.log("row.progressiveProfit",  row.progressiveProfit)
                if (row.progressiveProfit && max_m < row.progressiveProfit){
                    console.log("max m changed",max_m,  row.progressiveProfit)
                    max_m = row.progressiveProfit;
                }
                if (row.qCol == 1 && row.rCol == 1)
                    qr_match = true;

                _filtered.push({
                    multi:             row.multi,
                    event:             row.event,
                    newTargetStart:    row.newTargetStart,
                    backLay:           row.backLay,
                    odd:               row.odd,
                    stake:             row.stake,
                    outcome:           row.outcome,
                    realProfit:        row.realProfit,
                    maxGrossProfit:    row.maxGrossProfit,
                    netProfit:         row.netProfit,
                    progressiveProfit: row.progressiveProfit,
                    currentBank:       row.currentBank,
                    bf:                row.bf,
                    // rCol: row.rCol,
                    // qCol: row.qCol,
                    // afCol: row.afCol,
                    // adCol: row.adCol,
                    // aeCol: row.aeCol,
                    // agCol: row.agCol,
                    // ahCol: row.ahCol,
                    // yCol: row.yCol,
                    // acCol: row.acCol,
                    // aiCol: row.aiCol,
                    // aqCol: row.aqCol,
                    // vCol: row.vCol
                });
                this.moneyRows[i] = row;

                console.log("=============row", row)

                if ( row.progressiveProfit && parseFloat(row.progressiveProfit) < min_progressiveProfit )
                    min_progressiveProfit = parseFloat(row.progressiveProfit);
                if (( row.odd && !row.outcome && row.stake  ) && current_risk == 0 ) {
                    if (row.backLay == "Back")
                        current_risk = row.stake;
                    else
                        current_risk = row.stake * row.odd - row.stake;
                    // break;
                }
                if ( row.odd && row.outcome && row.stake ) {
                    
                    current_bank = row.currentBank;
                    if (row.outcome == "P")
                        max_risk_current = row.maxGrossProfit;
                    else
                        max_risk_current = 0;

                }

                if (row.outcome == "V" && row.realProfit == "")
                    outcome_won += 1;
                else if (row.outcome == "P" && row.realProfit == "")
                    outcome_loss += 1;

                if (row.realProfit && parseFloat(row.realProfit) > 0 )
                    realProfit_won += 1;
                else if (row.realProfit && parseFloat(row.realProfit) < 0 )
                    realProfit_loss += 1;

            }
            this.mainData.max_risk_achieved = min_progressiveProfit;
            this.mainData.current_risk = current_risk;
            this.mainData.max_risk_current = max_risk_current;

            this.mainData.won = outcome_won + " : " + realProfit_won;
            this.mainData.loss = outcome_loss + " : " + realProfit_loss;

            this.mainData.current_bank = current_bank;
            if (this.mainData.budget && current_bank)
                this.mainData.current_roi = (current_bank - this.mainData.budget) / this.mainData.budget * 100;

            if (this.mainData.strikes == "")
                this.mainData.strikes_left = "";
            else if (_filtered.length > 0 && _filtered[0].outcome == "")
                this.mainData.strikes_left = this.mainData.strikes;
            else {
                if (max_m == 0){
                    console.log("strikes_left 0")
                    this.mainData.strikes_left = "";
                }
                else if (max_m >= this.mainData.roi_money || qr_match){
                    this.mainData.strikes_left = "End";
                    // console.log("strikes_left 1")
                    // this.mainData.strikes_left = max_r;
                }
                else {
                    console.log("strikes_left 2")
                    this.mainData.strikes_left = max_r;
                }

            }

            if ( this.mainData.strikes_left != "End" && this.mainData.strikes_left != "") {
                let strikes_left = Math.ceil(parseFloat(this.mainData.strikes_left));
                let not_settled_tips = this.moneyRows.filter( item => item.outcome == "");
                
                for ( var i=0; i<(strikes_left - not_settled_tips.length); i++ ) {
                    console.log("add ", i)
                    this.moneyRows.push({
                        
                        multi: "",
                        event: "",
                        newTargetStart: "",
                        backLay: "Back",
                        odd: "",
                        stake: "",
                        outcome: "",
                        realProfit: "",
                        maxGrossProfit: "",
                        netProfit: "",
                        progressiveProfit: "",
                        currentBank: "",
                        bf: "",
                        
                    })
                    _filtered.push({
                        
                        multi: "",
                        event: "",
                        newTargetStart: "",
                        backLay: "Back",
                        odd: "",
                        stake: "",
                        outcome: "",
                        realProfit: "",
                        maxGrossProfit: "",
                        netProfit: "",
                        progressiveProfit: "",
                        currentBank: "",
                        bf: "",
                        
                    })
                }
                
            }
        

            
            console.log("this.mainData.won", this.mainData.won)           
            return _filtered;

        },
        pCol6() {
            let _filtered = this.moneyRows.filter( item => item.newTargetStart == "Start");
            if (_filtered.length == 1) {
                let strikes = this.mainData.strikes;
                let new_target = this.mainData.new_target;
                if (!new_target)
                    new_target = strikes;
                // return this.pCol4 - 50;
                return new_target - strikes;
            }
            else
                return 0;
        }
    },
}
</script>
<style scoped>
    .positive-mark {
        color: green
    }
    .negative-mark {
        color: red
    }
    .leverage_color_weight {
        background-color: #FFC000;
    }
    .leverage_color_light {
        background-color: #FFF2CC !important;
    }
    .comp_color_weight {
        background-color: #9BC2E6;
    }
    .comp_color_light {
        background-color: #DDEBF7 !important;
    }
    .cell_left_solid {
        /*border-left: solid !important;
        border-left-color: black !important;*/
        border-left: groove;
    }
    .cell_right_solid {
        /*border-right: solid !important;
        border-right-color: black !important;*/
        border-right: groove;
    }

    .money-detail .table-responsive{
        margin-top: 20px !important;
        max-height: 70vh !important;
    }
    .stick-head {
        padding: 3px;
        position: sticky;
        top: 0;
        z-index: 1;
        /* width: 25vw; */
        background: white;
    }
    

</style>
<style>





.first_tr{
    background-color: #bae1aa ;
}
.first_tr + tr{
    background-color: #dff0d8;
}
.leverage_color_light {
    background-color: #FFF2CC !important;
}
.comp_color_weight {
    background-color: #9BC2E6;
}
.comp_color_light {
    background-color: #DDEBF7 !important;
}
.cell_left_solid {
    /*border-left: solid !important;
    border-left-color: black !important;*/
    border-left: groove;
}
.cell_right_solid {
    /*border-right: solid !important;
    border-right-color: black !important;*/
    border-right: groove;
}
.outcome-col {
    color:  white;
    min-width: 35px;
    display: inline-block;
    border-radius: 5px;
}
.green-background {
    background-color:  green;
}
.red-background {
    background-color:  red;
}

.bg_outcome_v select {
    background-color: #00FF00 !important;
    font-weight: bold;
    color:  black !important;
}
.bg_outcome_p select {
    background-color: #FF0000 !important;
    font-weight: bold;
    color:  black !important;
}
.bg_outcome_void select {
    background-color: #3366FF !important;
    font-weight: bold;
    color:  white !important;
}
.bg_newtarget_start select{
    background-color: #0000FF !important;
    color:  white !important;
}
.bg_multi_green select{
    background-color: #92D050 !important;
}
</style>